"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AILinkClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var utils_1 = require("../utils");
var AILinkClick = function (event) {
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.AILinkClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.AILinkClick,
        link: {
            linkTitle: event.eventData.link.linkTitle || consts_1.NOT_AVAILABLE,
            linkModule: event.eventData.link.linkModule || consts_1.NOT_AVAILABLE,
            targetURL: event.eventData.link.targetURL || consts_1.NOT_AVAILABLE,
            responseID: event.eventData.link.responseID || consts_1.NOT_AVAILABLE,
        },
    };
    return (0, utils_1.checkDataLayerValueEmpty)(eventData);
};
exports.AILinkClick = AILinkClick;
